import React, { useState, useEffect } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './ListingPage.module.css';
import { formatMoney } from '../../util/currency';
import config from '../../config';
import { types as sdkTypes } from '../../util/sdkLoader';
import { RiChatFollowUpFill } from 'react-icons/ri';

const { Money } = sdkTypes;

const formatPrice = (price, intl) => {
  return formatMoney(intl, new Money(price, config.currency));
};

const SectionPricingMaybe = props => {
  const {
    description,
    publicData,
    intl,
    onBookingSubmit,
    showContactUser,
    onContactUser,
    setSelectedPlan,
  } = props;

  const rawPrices = publicData?.prices;
  const LOW_PRICE_THRESHOLD = 1200;
  const prices = rawPrices
    ? rawPrices
        .map((p, origIdx) => ({ ...p, _origIdx: origIdx }))
        .sort((a, b) => {
          const aLow = a.price < LOW_PRICE_THRESHOLD ? 1 : 0;
          const bLow = b.price < LOW_PRICE_THRESHOLD ? 1 : 0;
          if (aLow !== bLow) return aLow - bLow;
          return a.price - b.price;
        })
    : null;
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (setSelectedPlan && prices) {
      setSelectedPlan(prices[activeTab]._origIdx);
    }
  }, [activeTab]);

  if (!description || !prices || prices.length === 0) return null;

  const activePlan = prices[activeTab];

  const handleTabClick = i => {
    setActiveTab(i);
  };

  const handleContinue = () => {
    onBookingSubmit({ selectedPlan: activePlan._origIdx });
  };

  return (
    <div className={css.sidePanel}>
      {prices.length > 1 && (
        <div className={css.sidePanelTabs}>
          {prices.map((plan, i) => (
            <button
              key={i}
              type="button"
              className={`${css.sidePanelTab} ${activeTab === i ? css.sidePanelTabActive : ''}`}
              onClick={() => handleTabClick(i)}
            >
              {plan.title || `Package ${i + 1}`}
            </button>
          ))}
        </div>
      )}

      <div className={css.sidePanelBody}>
        {activePlan.title && (
          <div className={css.sidePanelLabel}>{activePlan.title}</div>
        )}

        <div className={css.sidePanelPrice}>
          {formatPrice(activePlan?.price, intl)}
        </div>

        {activePlan.description && (
          <p className={css.sidePanelDesc}>{activePlan.description}</p>
        )}

        {activePlan.method && (
          <div className={css.sidePanelMeta}>
            <RiChatFollowUpFill className={css.sidePanelMetaIcon} />
            <span>
              {config.custom?.tierMethodOptions?.find(e => e.key === activePlan.method)?.label || activePlan.method}
            </span>
          </div>
        )}

        <button
          type="button"
          className={css.sidePanelContinue}
          onClick={handleContinue}
        >
          Continue
          <span className={css.sidePanelArrow}>&rarr;</span>
        </button>

        {showContactUser && (
          <button
            type="button"
            className={css.sidePanelContact}
            onClick={onContactUser}
          >
            <FormattedMessage id="ListingPage.contactUser" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SectionPricingMaybe;
